export enum RichTextMode {
  STANDARD = 'standard',
  CENTERED = 'centered',
  /**
   * h2-h3: dividers using `mixed` color scheme
   * h1, h4-h6: standard
   */
  MODE1 = 'mode1',
  /**
   * H1 & H2 are presented as HeadlineDividers
   * H3 represents a SubjectBlock heading, succeeding content will be nested until the next H1, H2, or H3 is reached
   */
  MODE2 = 'mode2',
  /**
   * h1 is standard, h2 becomes divider heading, h3 and below gets formatted into a grid
   */
  MODE3 = 'mode3',
  /**
   * All headings are interpreted as an accordion header
   * Anything other than headings is grouped into an accordion panel
   */
  ACCORDION = 'accordion',
}

export type RichTextOptions = {
  size?: number;
  alignment?: RichTextAlignment;
  mode?: RichTextMode;
  isContent?: boolean;
  group?: boolean;
};

export enum RichTextAlignment {
  LEFT = 'left',
  RIGHT = 'right',
  CENTER = 'center',
}
